// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","sectionWrapper":"heroCarousel_sectionWrapper__uqGws"};